import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="w-full px-6 md:px-12 py-8" data-id="element-217">
      <div className="max-w-7xl mx-auto" data-id="element-218">
        {/* Desktop Layout - New Design */}
        <div className="hidden md:block relative w-full rounded-2xl overflow-hidden" data-id="element-219">
          {/* Background Image */}
          <img src="https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg" alt="Offshore oil platform at sunset" className="w-full h-[600px] lg:h-[700px] object-cover object-center" data-id="element-220" />

          {/* Gradient Overlay - Bottom */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-221" />

          {/* Content - Bottom Left */}
          <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-12" data-id="element-222">
            <div className="max-w-2xl" data-id="element-223">
              <h1 className="text-3xl lg:text-5xl font-bold text-white mb-4 leading-tight drop-shadow-lg" data-id="element-224">
                {t('hero.title')}
              </h1>
              <p className="text-white/95 text-base lg:text-lg leading-relaxed mb-6 drop-shadow-md" data-id="element-225">
                {t('hero.description')}
              </p>
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-226">
                <button className="px-6 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-md hover:opacity-90 transition-opacity shadow-lg" data-id="element-227">
                  {t('hero.discussTask')}
                </button>
                <button className="px-6 py-3 bg-white/95 text-[var(--color-dark)] text-sm font-medium rounded-md hover:bg-white transition-colors shadow-lg" data-id="element-228">
                  {t('hero.submitProfile')}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout: Title → Image → Description → Buttons */}
        <div className="md:hidden space-y-6" data-id="element-229">
          {/* Title - Centered */}
          <h1 className="text-3xl font-bold text-[var(--color-dark)] leading-tight text-center" data-id="element-230">
            {t('hero.title')}
          </h1>

          {/* Image - Show platform clearly centered */}
          <div className="relative w-full rounded-2xl overflow-hidden" data-id="element-231">
            <img src="https://cdn.magicpatterns.com/uploads/hd63eWM8qU6xYgaTeUajxL/fe82af34c545db296387cb3852bc1586e5585ff9.jpg" alt="Offshore oil platform at sunset" className="w-full h-[300px] object-cover" style={{
            objectPosition: '50% 50%'
          }} data-id="element-232" />
          </div>

          {/* Description */}
          <p className="text-[var(--color-dark)]/80 text-sm leading-relaxed text-center" data-id="element-233">
            {t('hero.description')}
          </p>

          {/* Buttons */}
          <div className="flex flex-col gap-3" data-id="element-234">
            <button className="w-full px-5 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-md hover:opacity-90 transition-opacity" data-id="element-235">
              {t('hero.discussTask')}
            </button>
            <button className="w-full px-5 py-3 bg-[var(--color-tan)] text-white text-sm font-medium rounded-md hover:opacity-90 transition-opacity" data-id="element-236">
              {t('hero.submitProfile')}
            </button>
          </div>
        </div>

        {/* Tagline below hero */}
        <p className="text-center text-[var(--color-text-light)] text-sm mt-6" data-id="element-237">
          {t('hero.tagline')}
        </p>
      </div>
    </section>;
}